import type {
  ExternalRefCapabilityUsageResponse,
  ExternalRefCapabilityUsageViewModel,
  BatchJobSummaryResponse,
  BatchJobSummaryViewModel,
} from "@models/monitoring";

export const buildBatchJobSummaryViewModel = (
  response: BatchJobSummaryResponse,
): BatchJobSummaryViewModel => {
  const createdBy = response.created_by;
  const fullName = createdBy
    ? [createdBy.first_name, createdBy.last_name]
        .filter((part): part is string => Boolean(part))
        .join(" ")
        .trim() ||
      createdBy.email ||
      null
    : null;

  return {
    jobId: response.job_id,
    pluginId: response.plugin_id,
    service: response.service,
    status: response.status,
    inputKind: response.input_kind,
    filename: response.filename,
    rowsTotal: response.rows_total,
    rowsDone: response.rows_done,
    error: response.error ?? null,
    createdBy: fullName,
    createdAt: new Date(response.created_at),
    updatedAt: new Date(response.updated_at),
  };
};

export const buildExternalRefCapabilityUsageViewModel = (
  response: ExternalRefCapabilityUsageResponse,
): ExternalRefCapabilityUsageViewModel => ({
  capability: response.capability,
  eventCount: response.event_count,
  totalCost: response.total_cost,
  currency: response.currency,
  inputCost: response.input_cost,
  outputCost: response.output_cost,
  inputTokens: response.input_tokens,
  outputTokens: response.output_tokens,
  totalTokens: response.total_tokens,
  pagesProcessed: response.pages_processed,
});
